import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Text, useToast } from "@chakra-ui/react";
import { organizationQuestionnaireKeys } from "../../../../../../hooks/query";
import { FormInput } from "components/Forms";
import { useQueryClient } from "react-query";
import CategoryForm from "./CategoryForm";
import { useCreateProcessingOfSoldProductsCategory, useUpdateProcessingOfSoldProductsCategory } from "hooks/query/scope-3";
import { showErrorToast, showSuccessToast, translateSubElementString } from "../../../../../../utils";

function CategoryProcessingOfSoldProducts({ defaultValues, tabKey, handleCategoryChange, finalize, finalizeQuestionnaire }) {
	const toast = useToast();
	const queryClient = useQueryClient();
	const { id: questionnaireId, categories: { processingOfSoldProducts: { co2Emission, id: categoryId } } } = defaultValues;
	const { t } = useTranslation("translation", {
		keyPrefix: "organizationQuestionnaire.scope3",
	});

	const processingOfSoldProductsDefaultValues = {
		co2Emission: co2Emission ?? "",
	};

	const {
		register,
		handleSubmit,
		formState: { errors, isDirty },
	} = useForm({
		defaultValues: processingOfSoldProductsDefaultValues,
	});

	const formId = `formStep${tabKey}`;

	const queryConfig = {
		onSuccess: () => {
			showSuccessToast(toast, "Category Processing of Sold Products saved!");
			if (finalize) {
				finalizeQuestionnaire(questionnaireId);
			} else {
				queryClient.invalidateQueries(organizationQuestionnaireKeys.orgQuestionnaireById());
				if (!isLoadingOnCreate && !isLoadingOnUpdate) {
					handleCategoryChange();
				}
			}
		},
		onError: err => {
			showErrorToast(toast, err.message);
		}
	};

	const { mutate: create, isLoading: isLoadingOnCreate } = useCreateProcessingOfSoldProductsCategory(queryConfig);
	const { mutate: update, isLoading: isLoadingOnUpdate } = useUpdateProcessingOfSoldProductsCategory(queryConfig);

	const onSubmit = ((data) => {
		if (isDirty) {
			categoryId
				? update({ questionnaireId, id: categoryId, data })
				: create({ questionnaireId, data });
		} else {
			finalize ? finalizeQuestionnaire(questionnaireId) : handleCategoryChange();
		}
	});

	return (
		<CategoryForm onSubmit={handleSubmit(onSubmit)} id={formId}>
			<Text opacity="0.75" fontSize="sm" marginBlockEnd="4">
				{t(`categories.${tabKey}Desc`)}
			</Text>
			<FormInput
				label={translateSubElementString(`organizationQuestionnaire.scope3.inputs.tCO2e`)}
				type="number"
				errors={errors}
				{...register("co2Emission")}
				isDisabled={true}
			/>
		</CategoryForm>
	);
}

export default CategoryProcessingOfSoldProducts;

